<div class="modal-header">
    <h3 class="modal-title" id="modal-title">Load Size</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.close()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body" id="modal-body">
    <p>
        <strong>Concurrent users</strong>
        : This is the maximum number of Virtual users application will be load tested. Please refer Ramp-up for more details on user distribution mechanism.</p>

    <p>
        <strong>Ramp-up Time</strong>
        : This option is used to gradually increase the amount of Vusers/load on the server. Required time to pump maximum virtual users to the system.</p>

    <p>
        <strong>Duration</strong>
        : This is the maximum number of Virtual users application will be load tested. Please refer Ramp-up for more details on user distribution mechanism.</p>

    <p>Please refer the below example for more details : If a user wants a load test with below parameters,
    </p>
    <p>
        <strong>Concurrent users</strong>
        – 25</p>
    <p>
        <strong>Ramp-up
        </strong>
        – 3 minutes</p>
    <p>
        <strong>Duration
        </strong>
        – 30 seconds</p>

    <p>Then the load testing preview will be as follows :</p>
    <div style="overflow : auto">
        <img src="/assets/images/performance/text-sizing-graph.jpg" />
    </div>
</div>
